import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cr-primary)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px 20px' }}>
        <h1 style={{ color: 'white', fontSize: '24px', fontWeight: '700' }}>Connected Rider</h1>
      </div>

      <div style={{ background: 'white', borderRadius: '24px 24px 0 0', padding: '28px 24px 40px' }}>
        {sent ? (
          <>
            <h2 style={{ marginBottom: '12px', textAlign: 'center' }}>Check your email</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '20px' }}>
              If that email has an account, a reset link is on its way. The link expires in 60 minutes.
            </p>
            <p style={{ fontSize: '13px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '24px' }}>
              Nothing arrived? Check your spam folder, or try again in a few minutes.
            </p>
            <Link to="/login" className="btn btn-primary btn-full btn-lg" style={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              Back to sign in
            </Link>
          </>
        ) : (
          <>
            <h2 style={{ marginBottom: '8px', textAlign: 'center' }}>Forgot your password?</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '20px' }}>
              Enter your email and we'll send you a link to choose a new one.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input className="form-input" type="email" placeholder="your@email.com"
                  value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
              </div>
              <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: '8px' }}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px' }}>
              <Link to="/login" style={{ color: 'var(--cr-primary)', fontWeight: '500', textDecoration: 'none' }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
